/**
 * Environment-aware logging utility
 * Only logs in development mode to prevent sensitive data exposure in production
 */

const isDev = import.meta.env.DEV;

export const safeLog = {
  log: (message: string, ...args: unknown[]) => {
    if (isDev) {
      console.log(message, ...args);
    }
  },
  
  error: (message: string, error?: unknown) => {
    if (isDev) {
      console.error(message, error);
    } else {
      // In production, only log generic message without details
      console.error(message);
    }
  },
  
  warn: (message: string, ...args: unknown[]) => {
    if (isDev) {
      console.warn(message, ...args);
    }
  },
  
  debug: (message: string, ...args: unknown[]) => {
    if (isDev) {
      console.debug(message, ...args);
    }
  }
};
